module.exports = __webpack_public_path__ + "img/543024289d0ae9274b12f8a384d6430f.png";